export default __webpack_public_path__ + "static/media/session-reload-hover.ffbb1e10.svg";